import { AfterViewChecked, AfterViewInit, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import {DataService} from '../../../../../Services/data.service';
import { AppConfigService } from '../../../../../Services/app-config.service';
import { StorageService } from '../../../../../Services/storage.service';
import { Title } from '@angular/platform-browser';
import { FilterPipe } from 'ngx-filter-pipe';
import { ActivatedRoute, Router } from '@angular/router';
import { EmailService } from '../../../../../Services/email.service';
import { DateFilterService } from '../../../../../Services/dateFilter.service';
import { EmailPassDataServiceService } from '../../../../../Services/email-pass-data-service.service';
import { ResponseModel } from '../../../../../DataModels/response-model';
import { BsToastService } from '../../../../../Services/bs-toast-service';
import {EmailModel} from '../../../../../DataModels/email-model';
import {Modal} from 'bootstrap';
import {DataExportService} from '../../../../../Services/dataExport.service';
import {ReportPrintService} from '../../../../../Services/report-print.service';

@Component({
  selector: 'app-transfer-report',
  templateUrl: './transfer-report.component.html',
  styleUrls: ['./transfer-report.component.css'],
  standalone: false
})
export class TransferReportComponent implements OnInit, AfterViewInit, AfterViewChecked {
  constructor(
    public localStorage: StorageService,
    public tableDataService: DataService,
    private titleService: Title,
    public appConfigService: AppConfigService,
    public route: ActivatedRoute,
    public aEmail: EmailService,
    public notification: BsToastService,
    private fb: UntypedFormBuilder,
    public dateFilter: DateFilterService,
    private emailData: EmailPassDataServiceService,
    public router: Router,
    private excelExporter: DataExportService,
    private reportPrint: ReportPrintService
  ) {
    this.timeOut = this.appConfigService.toastrWarnTimeOut;

    this.vm.Preferences = JSON.parse(this.localStorage.StorageGet('Preferences'));
    this.vm.permissions = JSON.parse(this.localStorage.StorageGet('Permissions'));
    this.vm.email.toemail = this.localStorage.StorageGet('ToEmail', '');
  }

  @ViewChild('EmailContent', { static: false }) EmailContent: ElementRef;
  @ViewChild('ExcelExport', {static: false}) ExcelExport: ElementRef;
  emailForm: UntypedFormGroup;
  private rptName: string;
  timeOut = 0;
  public urlParams: any = [];
  public emailInvalidMsg: string;

  // Email modal integration
  reportDataToSendInEmail: EmailModel = new EmailModel();

  public vm: any = {
    toDateSelect: [],
    fromDateSelect: [],
    DataFormat: 'MM/DD/YYYY',
    dateError: false,
    report: [],
    request: {
      toDate: null,
      fromDate: null,
      company_id: null,
      from_location_id: null,
      to_location_id: null,
      currency_id: null,
      includeUnposted: null,
      item_id: null,
      columns: null,
      location_id: null,
    },
    showSpecificDates: false,
    buttonsDisabled: false,
    d: {
      date: '',
      name: '',
    },
    columns: false,
    company: [],
    locationGroup: [],
    location: [],
    currency: [],
    filtered: false,
    showFilters: false,
    toDateError: false,
    monthCount: 0,
    companyData: null,
    locationData: null,
    inventoryItem: [],
    calculatedTime: new Date(),
    priorToDate: 0,
    ToEmailError: null,
    showEmail: true,
    ToEmail: null,
    emailed: null,
    email: {
      toemail: null,
      fromemail: this.appConfigService.SysEmailAddress,
      PdfHtml: null,
      Subject: null,
    },
    Preferences: null,
    permissions: null,
    fromDateError: null,
    netIncomeCurrent: null,
    netIncomePrior: null,
    companyId: null,
    currencyId: null,
    locationId: null,
    companyName: null,
    locationName: null,
    inventoryItemName: [],
    inventoryItemInput: '',
    inventoryItemFilter: { search_string: null },
  };
  public submitted = false;

  ngOnInit() {
    this.newDateFilter(this.vm.request.toDate, this.vm.request.fromDate);
    this.FilterOptionsInit();
    this.rptName = 'Inventory Transfer Report';
  }

  ngAfterViewChecked() {
    // Legacy email pass-through removed in favor of SendEmailModalComponent
  }

  onSubmit() {
    this.emailForm.reset();
  }

  ngAfterViewInit() {
    this.titleService.setTitle(this.rptName);
    // console.log('Time Out --> ' + this.timeOut);
  }

  newDateFilter(toDate, fromDate) {
    const ret = this.dateFilter.DateFilterInit(toDate, fromDate);
    this.vm.fromDateSelect = ret.fromDateSelect;
    this.vm.toDateSelect = ret.toDateSelect;
    this.vm.monthCount = ret.monthCount;
  }

  FilterOptionsInit() {
    this.tableDataService
      .getData('company?state=active&pageNumber=0&pageSize=999999')
      .subscribe((result: ResponseModel) => {
        this.vm.company = result.Data;
      });
    this.tableDataService
      .getData('location?state=active&pageNumber=0&pageSize=999999')
      .subscribe((result: ResponseModel) => {
        this.vm.location = result.Data;
      });
    this.tableDataService
      .getData('item?state=active&pageNumber=0&pageSize=999999')
      .subscribe((result: ResponseModel) => {
        const data: any = result.Data;
        this.vm.inventoryItem = data;
        for (const [x, value] of Object.entries(this.vm.inventoryItem)) {
          this.vm.inventoryItemName.push({ name: this.vm.inventoryItem[x].search_string });
        }
      });
    this.tableDataService
      .getData('currency?state=active&pageNumber=0&pageSize=999999')
      .subscribe((result: ResponseModel) => {
        this.vm.currency = result.Data;
      });

    // if (this.localStorage.StorageGet('company', '')) {
    //   this.vm.company = this.localStorage.StorageGet('company', '');
    // } else {
    //   this.localStorage.StorageSet('company', this.vm.company);
    // }
    // if (this.localStorage.StorageGet('location', '')) {
    //   this.vm.location = this.localStorage.StorageGet('location', '');
    // } else {
    //   this.localStorage.StorageSet('location', this.vm.location);
    // }
    // if (this.localStorage.StorageGet('inventoryItem', '')) {
    //   this.vm.inventoryItem = this.localStorage.StorageGet('inventoryItem', '');
    // } else {
    //   this.localStorage.StorageSet('inventoryItem', this.vm.inventoryItem);
    // }
    // if (this.localStorage.StorageGet('currency', '')) {
    //   this.vm.currency = this.localStorage.StorageGet('currency', '');
    // } else {
    //   this.localStorage.StorageSet('currency', this.vm.currency);
    // }

    if (this.urlParams.to_locationId) {
      this.vm.request.to_location_id = this.urlParams.to_locationId;
    }

    if (this.urlParams.from_locationId) {
      this.vm.request.from_location_id = this.urlParams.from_locationId;
    }
    if (this.urlParams.currency_id) {
      this.vm.request.currency_id = this.urlParams.currency_id;
    }

    for (const [x, value] of Object.entries(this.vm.inventoryItem)) {
      this.vm.inventoryItemName.push({ name: this.vm.inventoryItem[x].search_string });
    }

    if (
      this.vm.request.toDate &&
      this.vm.request.fromDate &&
      (this.urlParams.companyId || this.urlParams.currencyId || this.urlParams.locationId)
    ) {
      this.update();
    }
  }

  // Unified print entry point
  printReport() {
    try {
      const html = this.buildPrintHtml(false);
      this.printHtmlInIframe(html);
    } catch (e) {
      // fallback to browser print if something goes wrong
      window.print();
    }
  }

  encodeQueryData(data) {
    const ret = [];
    for (const d in data) {
      if (data[d] != null && data[d] != '') {
        ret.push(encodeURIComponent(d) + '=' + encodeURIComponent(data[d]));
      }
    }
    return ret.join('&');
  }

  update() {
    let errorDescription = '';
    this.vm.toDateError = this.vm.fromDateError = false;
    if (!this.vm.request.fromDate) {
      this.vm.dateError = true;
      errorDescription += $localize`:From date is required. @@From date is required.:From date is required.` + ' ';
    }
    if (!this.vm.request.toDate) {
      this.vm.dateError = true;
      errorDescription += $localize`:To date is required. @@todateisrequired:To date is required.` + ' ';
    }

    const tempToDate: any = new Date(this.vm.request.toDate);
    const tempFromDate: any = new Date(this.vm.request.fromDate);
    if (tempToDate < tempFromDate) {
      errorDescription += $localize`:From date must be less than the To date @@fromdatemustbelessthantheTodate:From date must be less than the To date`;
      this.vm.toDateError = true;
      this.vm.fromDateError = true;
    }
    if (errorDescription) {
      this.notification.showWarningToast(errorDescription);
    } else {
      this.vm.dateError = false;
      this.vm.monthCount = (tempToDate - tempFromDate) / 86400 / 30 / 1000;
      this.vm.request.toDate = this.dateFilter.GetDateFormat(this.vm.request.toDate);
      this.vm.request.fromDate = this.dateFilter.GetDateFormat(this.vm.request.fromDate);
      this.vm.buttonsDisabled = true;
      this.vm.netIncomeCurrent = this.vm.netIncomePrior = 0;

      const urlParamsJson = {
        currency_id: this.vm.request.currency_id,
        fromDate: this.vm.request.fromDate,
        toDate: this.vm.request.toDate,
        company_id: this.vm.request.company_id,
        from_location_id: this.vm.request.from_location_id,
        to_location_id: this.vm.request.to_location_id,
        pageSize: 99999999,
      };

      const TransferRerpotParam: string = this.encodeQueryData(urlParamsJson);

      this.tableDataService
        .getData('TransferReport', '?' + TransferRerpotParam)
        .subscribe((result: ResponseModel) => {
          this.vm.report = result.Data;
          this.vm.showFilters = this.vm.buttonsDisabled = false;
          this.vm.emailed = true;
          this.calcTotals();
          if (
            (this.vm.request.company_id && this.vm.company.length > 1) ||
            this.vm.request.from_location_id ||
            this.vm.request.to_location_id ||
            (this.vm.request.currency_id && this.vm.currency.length > 1)
          ) {
            this.vm.filtered = true;
          }
        });
    }
  }

  calcTotals() {
    for (const [x, value] of Object.entries(this.vm.report)) {
    }
  }

  setEmailData() {
    const emailDocObj = {} as EmailModel;
    const reportName = 'Inventory Transfer Report';

    // printing options
    emailDocObj.print_orientation = '1';
    emailDocObj.convert_attachment_to = 'pdf';

    emailDocObj.fromEmail = '';
    emailDocObj.fromName = 'AcctXErp';
    emailDocObj.header_id = '';
    emailDocObj.toEmail = '';
    emailDocObj.body = 'Please see the attached ' + reportName + '.<br><br><br>'
      + 'Best regards,'
      + '<br><br>'
      + 'AcctXErp'
      + '<br><br>';
    emailDocObj.Subject = 'AcctXErp ' + reportName;

    // Build unified HTML used for both Email and Print
    try {
      emailDocObj.pdfHtml = this.buildPrintHtml(true);
    } catch {
      // Fallback to raw export HTML if builder fails
      try {
        emailDocObj.pdfHtml = this.ExcelExport?.nativeElement?.outerHTML || document.getElementById('excel-export')?.outerHTML || '';
      } catch {
        emailDocObj.pdfHtml = '';
      }
    }
    emailDocObj.activity_message = reportName;

    // deterministic file name
    const now = new Date();
    const yyyy = String(now.getFullYear());
    const mm = String(now.getMonth() + 1).padStart(2, '0');
    const dd = String(now.getDate()).padStart(2, '0');
    emailDocObj.FileName = 'Inventory_Transfer_Report_' + yyyy + mm + dd + '.pdf';

    this.reportDataToSendInEmail = emailDocObj;

    const openModal = () => {
      const element = document.getElementById('sendEmailModal') as HTMLElement;
      if (element) {
        const emailModal = new Modal(element);
        emailModal.show();
      }
    };

    setTimeout(openModal, 0);
  }

  // Excel export using shared service and hidden table
  exportToExcel() {
    try {
      this.excelExporter.exportToExcel(this.ExcelExport, 'Inventory_Transfer_Report.xlsx');
    } catch (e) {
      // no-op
    }
  }

  // Build a self-contained HTML document for print/email from the hidden export block
  private buildPrintHtml(forEmail: boolean = false): string {
    const rawContent = (this.ExcelExport?.nativeElement?.outerHTML || document.getElementById('excel-export')?.outerHTML || '').toString();
    const content = this.reportPrint.cleanContentHtml(rawContent);
    const from = this.vm?.request?.fromDate || '';
    const to = this.vm?.request?.toDate || '';
    const meta: { label: string; value: string }[] = [];
    if (from || to) {
      meta.push({label: 'Period', value: from && to ? `${from} to ${to}` : (from || to)});
    }
    return this.reportPrint.buildHtml({title: 'Inventory Transfer Report', contentHtml: content, meta, orientation: 'landscape'});
  }

  private sanitizeVisibility(html: string): string {
    if (!html) {
      return '';
    }
    let out = html.replace(/\bd-none\b/g, '');
    out = out.replace(/\bhidden\b/g, '');
    // Remove inline display:none and visibility:hidden
    out = out.replace(/display\s*:\s*none\s*;?/gi, '');
    out = out.replace(/visibility\s*:\s*hidden\s*;?/gi, '');
    return out;
  }

  private printHtmlInIframe(html: string): void {
    this.reportPrint.printInIframe(html);
  }

  private escapeHtml(s: any): string {
    if (s === null || s === undefined) {
      return '';
    }
    return String(s)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  close() {
    this.router.navigateByUrl('/home').then();
  }

  clear() {
    this.vm.report = [];
    this.vm.request = {
      toDate: null,
      fromDate: null,
      company_id: null,
      from_location_id: null,
      to_location_id: null,
      currency_id: null,
      includeUnposted: null,
      item_id: null,
      columns: null,
      location_id: null,
    };
    this.vm.filtered = false;
  }

  FilterObject(value, filterObj, test = false) {
    return new FilterPipe().transform(value, filterObj);
  }

  updateInventoryItem() {
    this.vm.inventoryItemName = [];
    this.localStorage.StorageSet('inventoryItem', '');
    this.tableDataService.getData('item', '?state=active').subscribe((result) => {
      this.vm.inventoryItem = result;
      for (const [x, value] of Object.entries(this.vm.inventoryItem)) {
        this.vm.inventoryItemName.push({ name: this.vm.inventoryItem[x].search_string });
      }
    });
  }

  selectItemModal(itemId) {
    this.vm.request.item_id = itemId;
    for (const [x, value] of Object.entries(this.vm.inventoryItem)) {
      if (this.vm.inventoryItem[x].id === itemId) {
        this.vm.inventoryItemInput = this.vm.inventoryItem[x].code + ' ' + this.vm.inventoryItem[x].name;
        break;
      }
    }
  }

  testItem() {
    const itemIdStart = this.vm.request.item_id;
    if (!this.vm.inventoryItemInput || this.vm.inventoryItemInput == '') {
      this.vm.request.item_id = '';
    } else {
      if (this.FilterObject(this.vm.inventoryItem, { search_string: this.vm.inventoryItemInput }, true).length > 0) {
        this.vm.request.item_id = this.FilterObject(
          this.vm.inventoryItem,
          { search_string: this.vm.inventoryItemInput },
          true
        )[0].id;
      } else {
        this.vm.request.item_id = '';
        this.vm.inventoryItemInput = '';
      }
    }
    if (itemIdStart != this.vm.request.item_id) {
      this.vm.report = [];
    }
  }
}
